// polyfills
import 'core-js';
import 'react-app-polyfill/ie11';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';

import config from './config';
import _get from 'lodash/get';

// Styles
import 'styles/core.css';

// Components
import App from 'components/App';

if (config.SENTRY) {
  Sentry.init({
    dsn: config.SENTRY,
    environment: config.ENV,
  });
}

const INTERCOM_APP_ID = _get(config, 'ANALYTICS.INTERCOM.options.appId');

if (INTERCOM_APP_ID) {
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    custom_launcher_selector: ['#intercom-chat', '.intercom-chat'],
  };
}

ReactDOM.render(<App />, document.getElementById('root'));
